<form [formGroup]="nomineeForm">
    <p class="form-field-heading">Nominee Name</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="text" matInput formControlName="name" name="name" placeholder="Enter nominee name">
            <mat-error *ngIf="nomineeControls.name.errors">Please enter the nominee name</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Your Relationship With Nominee</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <mat-select formControlName="relation" placeholder="Select relationship with nominee">
                <mat-option *ngFor="let relation of relations"
                            [value]="relation.value">{{relation.displayName}}</mat-option>
            </mat-select>
            <mat-error *ngIf="nomineeControls.relation.errors">Please select your relationship with the nominee</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Is Nominee a Minor</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <mat-select (selectionChange)="updateMinorSelection($event)" formControlName="isMinor" placeholder="Select if nominee is a minor">
                <mat-option *ngFor="let option of ['Yes', 'No']" [value]="option">{{option}}</mat-option>
            </mat-select>
            <mat-error *ngIf="nomineeControls.isMinor.errors">Please select is nominee a minor</mat-error>
        </mat-form-field>
    </div>
    <div *ngIf="isMinor === false">
        <p class="form-field-heading">Nominee Contact Number</p>
        <div class="row">
            <mat-form-field class="col-xs-12">
                <input type="number" matInput formControlName="phoneNumber" name="phoneNumber" placeholder="Enter nominee contact number">
                <mat-error *ngIf="nomineeControls.phoneNumber.errors">Please enter valid phone number</mat-error>
            </mat-form-field>
        </div>

        <p class="form-field-heading">Nominee Email Id</p>
        <div class="row">
            <mat-form-field class="col-xs-12">
                <input type="text" matInput formControlName="emailId" name="emailId" placeholder="Enter nominee Email Id">
                <mat-error *ngIf="nomineeControls.emailId.errors?.required">Please enter nominee's email id</mat-error>
                <mat-error *ngIf="nomineeControls.emailId.errors?.email">Please enter valid email id</mat-error>
            </mat-form-field>
        </div>

        <p class="form-field-heading">Nominee Address</p>
        <div class="row">
            <mat-form-field class="col-xs-12">
                <input type="text" matInput formControlName="address" name="address" placeholder="Enter nominee address">
                <mat-error *ngIf="nomineeControls.address.errors">Please enter nominee's full address
                </mat-error>
            </mat-form-field>
        </div>
    </div>
</form>
<form [formGroup]="nomineeGuardianForm" *ngIf="isMinor === true">
    <p class="form-field-heading">Guardian Name</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="text" matInput formControlName="name" name="name" placeholder="Enter guardian's name">
            <mat-error *ngIf="nomineeGuardianControls.name.errors">Please enter guardian's name</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Guardian Contact Number</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="number" matInput formControlName="phoneNumber" name="phoneNumber" placeholder="Enter guardian's contact number">
            <mat-error *ngIf="nomineeGuardianControls.phoneNumber.errors">Please enter valid phone number</mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Guardian Email Id</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="text" matInput formControlName="emailId" name="emailId" placeholder="Enter guardian's Email Id">
            <mat-error *ngIf="nomineeGuardianControls.emailId.errors?.required">Please enter guardian's email id</mat-error>
            <mat-error *ngIf="nomineeGuardianControls.emailId.errors?.email">Please enter valid email id </mat-error>
        </mat-form-field>
    </div>

    <p class="form-field-heading">Guardian Address</p>
    <div class="row">
        <mat-form-field class="col-xs-12">
            <input type="text" matInput formControlName="address" name="address" placeholder="Enter guardian's address">
            <mat-error *ngIf="nomineeGuardianControls.address.errors">Please enter guardian's full address</mat-error>
        </mat-form-field>
    </div>
</form>
<div class="mt-3 mb-3" *ngIf="shouldAskConsent()">
    <mat-error *ngIf="termsNotCheckedError">Please provide your consent.</mat-error>
    <p>
        <mat-checkbox (change)="updateConsentCheckbox($event)" title="Please accept terms to proceed" required></mat-checkbox>&nbsp;&nbsp;

        I am aware that Bridge Fintech Solutions Private Limited will not be bound to transfer the units to the nominee
        in the event of any dispute in relation to the nominee’s entitlement.
        <br/>
        <br/>
        If Bridge Fintech Solutions Private Limited were to incur, suffers or any claim, demand, liabilities, proceedings
        or actions are filed or made or initiated against any of them in respect of or in connection with the
        nomination, they shall be entitled to be indemnified absolutely for any loss, expenses, costs,
        and charges that any of them may suffer or incur absolutely from my estate. I confirm to comply and adhere to
        such rules or any amendments that may be made from time to time.
    </p>
</div>
